import React from "react";
import { NavLink } from "react-router-dom";

const MenuItems = (props) => {
  const { parentMenu } = props;
  return (
    <React.Fragment>
      <li
        className={
          parentMenu === "about-us"
            ? "menu-item-has-children current-menu-item"
            : "menu-item-has-children"
        }
      >
        <a
          href="#"
          className={parentMenu === "about-us" ? "active-menu" : ""}
          onClick={(e) => e.preventDefault()}
        >
          About Us
        </a>
        <ul className="sub-menu submenu">
          <div className="border_menu ">
            <div className="row">
              <div className="col-lg-4">
                <div className="main_menu_inner mega_menu_set">
                  <ul>
                    <li>
                      <NavLink
                        to="/company-overview"
                        activeClassName="active-menu"
                      >
                        Company Overview
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/group-companies"
                        activeClassName="active-menu"
                      >
                        Group Companies
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-lg-4">
                <div className="main_menu_inner mega_menu_set">
                  <ul>
                    <li>
                      <NavLink
                        to="/leadership"
                        activeClassName="active-menu"
                      >
                        Leadership
                      </NavLink>{" "}
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-lg-4">
                <div className="main_menu_inner mega_menu_set">
                  <ul>
                    <li>
                      <NavLink
                        to="/global-presence"
                        activeClassName="active-menu"
                      >
                        Global Presence
                      </NavLink>{" "}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </ul>
      </li>

      <li
        className={
          parentMenu === "solution"
            ? "menu-item-has-children current-menu-item"
            : "menu-item-has-children"
        }
      >
        <a
          href="#"
          className={parentMenu === "solution" ? "active-menu" : ""}
          onClick={(e) => e.preventDefault()}
        >
          Services
        </a>
        <ul className="sub-menu submenu">
          <div className="border_menu ">
            <div className="row">
              <div className="col-lg-4">
                <div className="main_menu_inner mega_menu_set">
                  <ul>
                    <li>
                      <NavLink
                        to="/AI-LLM-Solutions"
                        activeClassName="active-menu"
                      >
                        AI & LLM Solutions
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/salesforce-consulting"
                        activeClassName="active-menu"
                      >
                        Salesforce Consulting
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/staff-augmentation"
                        activeClassName="active-menu"
                      >
                        Staff Augmentation (Dedicated Teams)
                      </NavLink>{" "}
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="main_menu_inner mega_menu_set">
                  <ul>
                    <li>
                      <NavLink
                        to="/blockchain"
                        activeClassName="active-menu"
                      >
                        Blockchain Development
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/web-mobile-app-development"
                        activeClassName="active-menu"
                      >
                        Web & Mobile App Development
                      </NavLink>{" "}
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="main_menu_inner mega_menu_set">
                  <ul>
                    <li>
                      <NavLink
                        to="/fintech-app-engineering"
                        activeClassName="active-menu"
                      >
                        Fintech Application Engineering
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/cloud-devops"
                        activeClassName="active-menu"
                      >
                        Cloud & DevOps
                      </NavLink>{" "}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </ul>
      </li>

      <li
        className={
          parentMenu === "products"
            ? "menu-item-has-children current-menu-item"
            : "menu-item-has-children"
        }
      >
        <a
          href="#"
          className={parentMenu === "products" ? "active-menu" : ""}
          onClick={(e) => e.preventDefault()}
        >
          Solutions
        </a>
        <ul className="sub-menu submenu">
          <div className="border_menu ">
            <div className="row">
              <div className="col-lg-4">
                <div className="main_menu_inner mega_menu_set">
                  <ul>
                    <li>
                      <a
                        href="https://www.voicerix.ai"
                        target="_blank"
                        rel="noreferrer"
                      >
                        VoiceRix
                      </a>
                    </li>
                    <li>
                      <span className="coming-soon-link">Eaglient</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="main_menu_inner mega_menu_set">
                  <ul>
                    <li>
                      <span className="coming-soon-link">Opteev</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="main_menu_inner mega_menu_set">
                  <ul>
                    <li>
                      <a
                        href="https://tradicorn.com/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Tradicorn
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </ul>
      </li>

      <li
        className={
          parentMenu === "resources"
            ? "menu-item-has-children current-menu-item"
            : "menu-item-has-children"
        }
      >
        <a
          href="#"
          className={parentMenu === "resources" ? "active-menu" : ""}
          onClick={(e) => e.preventDefault()}
        >
          Resources
        </a>
        <ul className="sub-menu submenu">
          <div className="border_menu ">
            <div className="row">
              <div className="col-lg-4">
                <div className="main_menu_inner mega_menu_set">
                  <ul>
                    <li>
                      <NavLink
                        to="/current-openings"
                        activeClassName="active-menu"
                      >
                        Careers
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        to="/contact-us"
                        activeClassName="active-menu"
                      >
                        Contact Us
                      </NavLink>{" "}
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="main_menu_inner mega_menu_set">
                  <ul>
                    <li>
                      <NavLink
                        to="/blog"
                        activeClassName="active-menu"
                      >
                        Blogs
                      </NavLink>{" "}
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="main_menu_inner mega_menu_set">
                  <ul>
                    <li>
                      <NavLink
                        to="/white-paper"
                        activeClassName="active-menu"
                      >
                        Whitepapers
                      </NavLink>{" "}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </ul>
      </li>

      <NavLink className="getTouch" to="/contact-us">
        Get In Touch
      </NavLink>
    </React.Fragment>
  );
};
export default MenuItems;
